import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=024dcad6&scoped=true&"
import script from "./DownloadFile.vue?vue&type=script&lang=js&"
export * from "./DownloadFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFile.vue?vue&type=style&index=0&id=024dcad6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024dcad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024dcad6')) {
      api.createRecord('024dcad6', component.options)
    } else {
      api.reload('024dcad6', component.options)
    }
    module.hot.accept("./DownloadFile.vue?vue&type=template&id=024dcad6&scoped=true&", function () {
      api.rerender('024dcad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/DownloadFile.vue"
export default component.exports